export const defaultGame = { name: 'Все виды спорта', id: 0 };
export const defaultArena = { name: 'Все арены', id: 0 };
export const defaultLevel = { name: 'Любой уровень', id: 0, label: undefined };
export const defaultEventType = { name: 'Все события', id: 'all' };